// extracted by mini-css-extract-plugin
export default {"iconDefault":"IncomeSource_iconDefault__ovkmT"};